/*
 * Public API Surface of angular-calendar
 */

export * from './modules/calendar.module';
export * from './date-adapters/date-fns';
